import { I18n } from "@assets/strings";
import React from "react";
import styled from "styled-components";
import { Path } from "@core/routing/path";
import { Post } from "@domain/post/post";
import { ClosableModal } from "@ui/modals/closableModal";
import { ShareOnSocialMedia } from "@ui/components/shareOnSocialMedia";
// import SocialSharing from "../socialSharing";
// import { Config } from "../../../core/config/config";

export interface SharePostModalProps extends React.HTMLAttributes<HTMLDivElement> {
	close: () => void;
	post: Post;
}

export const SharePostModal: React.FC<SharePostModalProps> = ({ close, post, ...htmlProps }) => {
	return (
		<Container title="Partager cette publication." close={close} {...htmlProps}>
			<ShareOnSocialMedia path={Path.Post(post.id)} message={I18n.t("social_sharing.message")} />
		</Container>
	);
};

const Container = styled(ClosableModal)`
	gap: 40px;
	align-items: baseline;
`;
